<template>
  <div>
    <ModalComponent
      class="[&_.full-screen-modal-close-button]:!hidden [&_.dialogOverlay]:!opacity-0 [&_.dialogNotVisible]:translate-y-1/2 [&_.dialogNotVisible]:!scale-100 [&_.dialogNotVisible]:!top-0 [&_.full-screen-modal-bg]:!bg-transparent"
      hashBase="new-deal"
      ref="dialog"
      headerBg="#fff"
    >
      <div class="w-full h-full relative">
        <div class="w-full h-full absolute" @click="$refs.dialog.hide()"></div>

        <NewDealAdder />
      </div>
    </ModalComponent>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '../utils/ModalComponentFullScreen.vue'
import NewDealAdder from './NewDealAdder.vue'

export default defineComponent({
  name: 'CartDialog',
  components: { NewDealAdder, ModalComponent },
  props: {},
  data() {
    return {
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'new_deal_adding_required',
      this.showDetails,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    showDetails() {
      setTimeout(() => {
        this.$refs.dialog.show()
      }, 300)
    },
  },
  computed: {},
})
</script>
